import { render, staticRenderFns } from "./CreditoTaller.vue?vue&type=template&id=3811f771"
import script from "./CreditoTaller.vue?vue&type=script&lang=js"
export * from "./CreditoTaller.vue?vue&type=script&lang=js"
import style0 from "./CreditoTaller.vue?vue&type=style&index=0&id=3811f771&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports